import React from 'react';
import { X } from 'lucide-react';
import { PhotoCaptureField } from './PhotoCaptureField';

export interface PhotoEnsemble { image: string; caption: string }

/**
 * Photos d'ensemble d'une prestation chez une entreprise (2026-10-19, demande d'Emeni) : au lieu d'une photo par chaise ou
 * par lit, le responsable prend quelques vues d'ensemble (jusqu'à 6) et les légende (« Étage 2 », « Salle de restaurant »).
 */
export function PhotosEnsembleField({ photos, onChange, max = 6, obligatoire }: { photos: PhotoEnsemble[]; onChange: (p: PhotoEnsemble[]) => void; max?: number; obligatoire?: boolean }) {
    const [attente, setAttente] = React.useState<string | null>(null);
    // Une photo qui vient d'être prise est ajoutée à la liste tout de suite ; le champ se vide pour la suivante.
    const ajouter = (image: string | null) => {
        if (!image) { setAttente(null); return; }
        onChange([...photos, { image, caption: '' }]);
        setAttente(null);
    };
    return (
        <div className="space-y-3">
            <p className="text-[10px] font-bold text-content-muted uppercase tracking-widest">
                Photos d'ensemble ({photos.length}/{max}){obligatoire ? ' — au moins une' : ' — facultatives'}
            </p>
            {photos.length > 0 && (
                <div className="grid grid-cols-2 gap-3">
                    {photos.map((p, i) => (
                        <div key={i} className="space-y-1.5">
                            <div className="relative rounded-xl overflow-hidden border border-border">
                                <img src={p.image} alt={p.caption || `Photo d'ensemble ${i + 1}`} className="w-full h-28 object-cover" />
                                <button type="button" onClick={() => onChange(photos.filter((_, k) => k !== i))} aria-label="Retirer la photo"
                                    className="absolute top-1.5 right-1.5 p-1 rounded-full bg-black/70 text-white hover:bg-black/90"><X size={12} /></button>
                            </div>
                            <input value={p.caption} maxLength={80} placeholder="Légende (ex. Étage 2)" aria-label={`Légende de la photo ${i + 1}`}
                                onChange={(e) => onChange(photos.map((x, k) => (k === i ? { ...x, caption: e.target.value } : x)))}
                                className="w-full bg-surface-soft border border-border rounded-lg px-2.5 py-1.5 text-xs text-content outline-none focus:border-brand-500" />
                        </div>
                    ))}
                </div>
            )}
            {photos.length < max && (
                <div className="space-y-1.5">
                    <PhotoCaptureField label={photos.length === 0 ? "Prendre une photo d'ensemble" : 'Ajouter une photo'} value={attente} onChange={ajouter} maxSize={1024} quality={0.75} allowLibrary />
                </div>
            )}
        </div>
    );
}
